export const practiceTestScore = [
    {name: 'Part One', progress: 87, time_taken: '35', content_question: '24', passage_quest: '21', calculation_error: '34'},
    {name: 'Part One', progress: 87, time_taken: '35', content_question: '24', passage_quest: '21', calculation_error: '34'}
];


// WEBPACK FOOTER //
// ./src/data/practiceTestScore.js